<template>
  <Modal
    :show="isModalOpen"
    container-class="atb-w-full"
    body-class="atb-border-none"
    footer-class="atb-flex atb-flex-row atb-justify-end atb-gap-8"
    @onModalClose="changeModalVisibility"
  >
    <template #header>
      {{ $t('deleteAllEntitiesMessage') }}
    </template>
    <template #body>
      <div id="entity">
        <div class="atb-flex atb-flex-row atb-gap-4 atb-pt-6 atb-px-4 atb-pb-4">
          <div class="atb-flex-grow">
            <div class="eds-table-wrap atb-w-full atb-h-full">
              <AgGridVue
                id="entityMassDeleteGrid"
                class="ag-theme-eds atb-w-full atb-h-full"
                :style="{ height: '250px' }"
                :columnDefs="columnDefs"
                :row-data="massDeleteDependencies"
                :suppressCellSelection="true"
                :suppressRowClickSelection="true"
                @grid-ready="onGridReady"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <Button
        id="massDeleteCancelButton"
        motif="basic"
        @click="changeModalVisibility"
      >
        {{ $t('cancel') }}
      </Button>
      <Button
        id="massDeleteConfirmButton"
        @click="deleteRecords"
      >
        {{ $t('delete') }}
      </Button>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
  import { ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
  import { reactive, ref, Ref, toRefs } from 'vue';
  import { useModal } from '@/app/shared/hooks/use-modal';
  import { useI18n } from 'vue-i18n';
  import Button from '@atb-ui/eds-vue/src/components/Button.vue';
  import Modal from '@atb-ui/eds-vue/src/components/Modal.vue';
  import { EntityReferencesDependencies } from '@/app/shared/types/entity-references-dependencies.interface';
  import { AgGridVue } from 'ag-grid-vue3/lib/AgGridVue';
  interface EntityDependencyEvent {
    (_event: 'massDeleteDependency'): void;
    (_event: 'delete'): void;
  }
  interface DependencyProps {
    massDeleteDependencies: Array<EntityReferencesDependencies>;
  }
  const props = defineProps<DependencyProps>();
  const emit = defineEmits<EntityDependencyEvent>();
  const { isModalOpen, changeModalVisibility } = useModal();
  const { t } = useI18n();
  const gridApi = ref(null) as Ref<GridApi | null>;
  const columnApi = reactive({}) as Ref<ColumnApi | null>;
  const onGridReady = (params: GridReadyEvent) => {
    gridApi.value = params.api;
    columnApi.value = params.columnApi;
    gridApi.value.sizeColumnsToFit();
  };
  const { massDeleteDependencies } = toRefs(props);
  const columnDefs = [
    {
      field: 'childreferenceShortName',
      headerName: t('childReferenceShortName'),
      suppressMovable: true,
      width: 250,
      minWidth: 250,
      sortable: false,
    },
    {
      field: 'parentReferenceShortName',
      headerName: t('parentReferenceShortName'),
      wrapText: true,
      resizable: true,
      autoHeight: true,
      suppressMovable: true,
      width: 250,
      minWidth: 250,
      sortable: false,
    },
  ];
  const deleteRecords = () => {
    changeModalVisibility();
    emit('delete');
  };

  defineExpose({
    changeModalVisibility,
  });
</script>
